export default __webpack_public_path__ + "static/media/7_Still.8ec07bfa.jpg";